<section
    id="location-insights"
    class="flex flex-col p-6 gap-6 border-solid border-1 border-sky-blue rounded-lg"
  >
    <!-- Header section with Title and actions -->
    <section
      id="location-insights-section-header"
      class="flex flex-col md:flex-row justify-between items-center pb-6 neptune-border-b-1 border-sky-blue"
    >
      <section
        id="location-insights-table-title"
        class="text-2xl text-neptune-color-primary"
      >
        Location Insights
      </section>

      <!-- Paginator and Add All -->
      <section id="location-insights-actions" class="flex gap-4">
        <div id="location-insights-paginator" class="flex items-center gap-1">
          <span class="text-sm">Show:</span>

          <single-select-input
            [options]="dropDownOptions"
            [value]="selectedDropDownOption"
            [displayFn]="displayOption"
            (valueChange)="onPageSizeChange($event)"
            class="border border-solid border-neptune-subtle rounded-md min-w-[80px]"
          >
          </single-select-input>
        </div>
        <div
          id="location-insights-add-all"
          class="flex items-center gap-2"
          *ngIf="
            this.currentDropDownValue.optionName != '5%' &&
            this.currentDropDownValue.optionName != '10%'
          "
        >
          <input
            type="checkbox"
            #addTopBottomLoc
            [checked]="checked"
            (click)="_onCheckedChange(addTopBottomLoc.checked)"
            id="add"
            name="add"
            class="w-4 h-4 accent-blue"
          />
          <label id="add-all-label" for="add">Add All</label>
        </div>
      </section>
    </section>
    <!-- Table with Bottom and Top Units data -->
    <section
      id="location-insights-table-section"
      *ngIf="!displayLoader; else locationInsightsTableSkeletonLoader"
    >
      <section
        id="location-insights-table-tabs"
        class="flex w-full bg-neptune-muted"
      >
        <div
          id="bottom-units-tab"
          [attr.aria-selected]="tabSelected === 'bottom'"
          class="px-4 py-3 flex items-center w-1/2 cursor-pointer justify-center font-medium"
          [ngClass]="
            tabSelected == 'bottom'
              ? 'neptune-border-b-2 border-blue'
              : 'neptune-border-b-1 border-neptune-border-subtle'
          "
          (click)="changeTab('bottom')"
        >
          Bottom Units
        </div>
        <div
          id="top-units-tab"
          [attr.aria-selected]="tabSelected === 'top'"
          class="px-4 py-3 flex items-center w-1/2 cursor-pointer justify-center font-medium"
          [ngClass]="
            tabSelected == 'top'
              ? 'neptune-border-b-2 border-blue'
              : 'neptune-border-b-1 border-neptune-border-subtle'
          "
          (click)="changeTab('top')"
        >
          Top Units
        </div>
      </section>

      <section
        id="location-insights-table"
        class="p-6 bg-neptune-color-primary-50 overflow-auto"
      >
        <table
          class="table-fixed box-border min-w-[720px] border-collapse w-full"
        >
          <colgroup>
            <!-- Location takes the remaining width after the fixed metric columns. -->
            <col />
            <col span="5" class="w-[14%]" />
          </colgroup>

          <thead id="location-insights-table-header">
            <tr
              class="text-left text-xs xl:text-sm font-medium text-black neptune-border-b-1 border-neptune-border-subtle bg-neptune-muted"
            >
              <th class="px-4 py-2">Location</th>

              <ng-container
                *ngTemplateOutlet="
                  sortableHeader;
                  context: {
                    column: 'extraServiceCalls',
                    label: 'Extra Service Calls',
                  }
                "
              ></ng-container>

              <th class="px-4 py-2">Avg. ESR</th>

              <ng-container
                *ngTemplateOutlet="
                  sortableHeader;
                  context: {
                    column: 'vsAvg',
                    label: 'Vs. Average',
                  }
                "
              ></ng-container>

              <ng-container
                *ngTemplateOutlet="
                  sortableHeader;
                  context: {
                    column: 'issues',
                    label: 'Issues',
                  }
                "
              ></ng-container>

              <ng-container
                *ngTemplateOutlet="
                  sortableHeader;
                  context: {
                    column: 'recurringIssues',
                    label: 'Recurring Issues',
                  }
                "
              ></ng-container>
            </tr>
          </thead>

          <tbody id="location-insights-table-body" class="bg-white">
            <tr *ngFor="let element of sortedData">
              <!-- Location -->
              <td class="location p-4 text-left">
                <div class="flex flex-col gap-1 min-w-0">
                  <!-- Name + Chevron Row -->
                  <div class="flex justify-start items-center gap-1 min-w-0">
                    <span
                      *ngIf="element.accountName"
                      class="location-name text-sm lg:text-base font-bold text-blue cursor-pointer line-clamp-2 min-w-0 hover:underline hover:decoration-2"
                      [title]="
                        element.accountName + ' ' + element.accountNumber
                      "
                      (click)="onAccountClick(element)"
                    >
                      {{ element.accountName }} {{ element.accountNumber }}
                    </span>

                    <span
                      (click)="onAccountClick(element)"
                      class="shrink-0 cursor-pointer self-center"
                    >
                      <img
                        src="/assets/shared-icons/neptune-icon-chevron-right.svg"
                        class="w-6 h-6 block"
                      />
                    </span>
                  </div>

                  <!-- Address Row -->
                  <div class="flex min-w-0">
                    <span
                      class="location-address text-neptune-default text-xs truncate block flex-1 min-w-0"
                      [title]="element.address"
                    >
                      {{ element.address }}
                    </span>
                  </div>
                </div>
              </td>
              <!-- Extra Service Calls -->
              <td class="extra-service-calls p-4 text-left">
                {{ element.extraServiceCalls | number: "1.0-0" : "en-US" }}
              </td>
              <!-- Avg. ESR -->
              <td class="avg-esr p-4 text-left">
                {{ $any(element).avgESR | number: "0.0-0" : "en-US" }}
              </td>
              <!-- Vs. Average -->
              <td class="vs-average p-4 text-left">
                <div
                  class="inline-block rounded p-2 text-center text-white text-base font-bold min-w-16"
                  [ngClass]="{
                    'bg-neptune-color-red-600': element.vsAvg >= 75,
                    'bg-neptune-color-orange-500':
                      element.vsAvg >= 25 && element.vsAvg < 75,
                    'bg-neptune-color-green-500': element.vsAvg < 25,
                  }"
                >
                  {{ element.vsAvg | number: "1.0-0" : "en-US" }}%
                </div>
              </td>
              <!-- Issues -->
              <td class="issues p-4 text-left">
                {{ element.issues | number: "1.0-0" : "en-US" }}
              </td>
              <!-- Recurring Issues -->
              <td class="recurring-issues p-4 text-left">
                {{ element.recurringIssues | number: "1.0-0" : "en-US" }}
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </section>
  </section>

<ng-template #sortableHeader let-column="column" let-label="label">
  <th
    class="px-4 py-2 cursor-pointer select-none group/col"
    (click)="onSortChange(column)"
  >
    <div class="flex items-center gap-1">
      {{ label }}

      <img
        src="assets/shared-icons/neptune-icon-arrow-upward.svg"
        alt="sort"
        class="w-6 h-6 transition-all duration-200"
        [ngClass]="{
          'opacity-0 group-hover/col:opacity-50': sortColumn !== column,
          'opacity-100 rotate-180':
            sortColumn === column && sortDirection === 'desc',
          'opacity-100': sortColumn === column && sortDirection === 'asc',
        }"
      />
    </div>
  </th>
</ng-template>

<ng-template #locationInsightsTableSkeletonLoader>
  <section
    id="locationInsightsTableSkeletonLoader"
    class="p-6 bg-neptune-color-primary-50 overflow-auto"
  >
    <table
      class="table-fixed box-border min-w-[720px] border-collapse w-full"
    >
      <colgroup>
        <col />
        <col span="5" class="w-[14%]" />
      </colgroup>

      <tbody class="bg-white animate-pulse">
        <tr *ngFor="let row of [1, 2, 3, 4, 5]">
          <td class="p-4">
            <div class="flex flex-col gap-2">
              <div class="h-4 w-48 bg-neptune-subtle rounded"></div>
              <div class="h-3 w-64 bg-neptune-subtle rounded"></div>
            </div>
          </td>

          <td class="p-4">
            <div class="h-4 w-10 bg-neptune-subtle rounded"></div>
          </td>

          <td class="p-4">
            <div class="h-4 w-10 bg-neptune-subtle rounded"></div>
          </td>

          <td class="p-4">
            <div class="h-8 w-16 bg-neptune-subtle rounded"></div>
          </td>

          <td class="p-4">
            <div class="h-4 w-10 bg-neptune-subtle rounded"></div>
          </td>

          <td class="p-4">
            <div class="h-4 w-10 bg-neptune-subtle rounded"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</ng-template>
